<script setup lang="ts">
import type { Component } from "vue";

import ChipRemoveButton from "~/components/dumb/ChipRemoveButton.vue";
import DropdownItemWrapper from "~/components/dumb/DropdownItemWrapper.vue";
import EntityPreviewTooltip from "~/components/dumb/EntityPreviewTooltip.vue";
import { CommandId } from "~/shared/enums";
import type { User } from "~/shared/types";
import { usePageStore } from "~/stores";

defineProps<{
  label: string;
  selected: boolean;
  replaceEnabled: boolean;
  icon: Component;
  iconArgs: object;
  user?: User;
  redirectEnabled?: boolean;
  navigateEnabled?: boolean;
  navigateTooltip?: string;
  isChip?: boolean;
}>();

const emit = defineEmits<{
  remove: [];
  replace: [];
  navigate: [];
}>();

const pageStore = usePageStore();
</script>

<template>
  <DropdownItemWrapper
    :selected="selected"
    :no-padding="selected && !pageStore.isMobile"
    :replace-enabled="!isChip && replaceEnabled"
    :link-indicator-enabled="!isChip && redirectEnabled"
    :navigate-enabled="!isChip && navigateEnabled"
    :navigate-tooltip="navigateTooltip"
    :command-id="CommandId.SWAP_ASSIGNEE"
    :class="['justify-between', pageStore.isMobile ? 'text-base' : 'grow overflow-hidden text-sm']"
    @replace="emit('replace')"
    @navigate="emit('navigate')">
    <EntityPreviewTooltip
      :user-duid="user?.duid"
      :distance="isChip ? undefined : 16"
      class="items-center overflow-hidden">
      <component :is="icon" v-bind="iconArgs" class="mr-1 shrink-0" />
      <div
        v-if="!pageStore.isMobile"
        class="flex items-center overflow-hidden rounded-sm py-0.5 pr-1 pl-1.5"
        :class="selected && 'bg-md'">
        <span :title="label" class="break-words pr-0.5 hyphens-auto text-md select-none">
          {{ label }}
        </span>
        <ChipRemoveButton :selected="selected" @remove="emit('remove')" />
      </div>
      <span v-else :title="label" class="pl-1.5 text-md select-none">{{ label }}</span>
    </EntityPreviewTooltip>
  </DropdownItemWrapper>
</template>
